import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPrices } from "../api";
import { ArrowRight, Info } from "lucide-react";

export default function PricingPreview() {
  const [prices, setPrices] = useState([]);
  useEffect(() => { getPrices().then(setPrices).catch(() => {}); }, []);

  return (
    <section className="py-20 section-cream">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="chip mb-4">Transparent Pricing</div>
          <h2 className="font-display text-3xl md:text-5xl font-medium leading-tight">Fair starting prices, no surprises</h2>
          <p className="text-slate-500 mt-3">Below are our starting service charges. Spare parts, if required, are charged separately after your approval.</p>
        </div>
        <div className="bg-white rounded-lg border border-neutral-200 overflow-hidden">
          <table className="table-clean w-full">
            <thead>
              <tr>
                <th>Service</th>
                <th className="text-right">Starting Price</th>
              </tr>
            </thead>
            <tbody>
              {prices.map((p) => (
                <tr key={p.id}>
                  <td className="font-medium">{p.label}</td>
                  <td className="text-right font-semibold text-[#0f172a]">{p.starting_price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-5 flex items-start gap-2 text-sm text-slate-500">
          <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />
          <p>Spare parts, if required, are charged separately after customer approval. GST applicable as per government rate.</p>
        </div>
        <div className="text-center mt-8">
          <Link to="/service-charges" className="btn-ghost">Full Service Charges <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    </section>
  );
}
